import React, { useState, useEffect } from "react";
import { useMsal } from "@azure/msal-react";
import { useNavigate } from "react-router-dom";
import { TailSpin } from "react-loader-spinner";
import axios from 'axios';
import { LocalStorageService } from "../service/LocalStorageService";
//import { Timesheet } from "../middleware/interceptor";
import { message } from "antd";
import { Timesheetapi } from "../../middleware/interceptor";
import { ErrorLog } from "../common/ErrorLog";

export const SSOSignin = ({ isAuthenticated, setEmp_Role, Emp_Role }) => {

  const { instance } = useMsal();
  const navigate = useNavigate();

  const [isLoading, setIsLoading] = useState(false);
  const [messageApi, contextHolder] = message.useMessage();
  const [login, setLogin] = useState(sessionStorage.getItem("Mslogin"));

  const success = (msg) => {
    messageApi.open({
      type: "success",
      title: "Success",
      content: msg,
      duration: 1.5,
    });
  };

  const error = () => {
    messageApi.open({
      type: "error",
      duration: 2,
      content: "Error While  Login!",
    });
  };


  const Loader =
    <TailSpin
      visible={true}
      height="30"
      width="50"
      radius="1"
    />;

  const handleSignInWithMicrosoft = async () => {
    instance.loginRedirect({
      scopes: ["user.read"],
    });
    sessionStorage.setItem("Mslogin", true);

    localStorage.removeItem("google_token")
  };

  useEffect(() => {
    const logError = async (errorMessage, methodName, username = null) => {
      // const errorLog = {
      //   Error_Message: errorMessage,
      //   Stack_Trace: '',
      //   Method_Name: methodName,
      //   File_Name: 'SSOSignin.js',
      //   User_Id: username,
      // };

      // await fetch("https://your-api-url/api/Projects/PutErrors", {
      //   method: "POST",
      //   headers: {
      //     "Content-Type": "application/json"
      //   },
      //   body: JSON.stringify(errorLog)
      // });
    };

    if (isAuthenticated) {
      try {
        const account = instance?.getActiveAccount();

        if (account) {
          const { name, username } = account;
          console.log("username", name, username);
          setIsLoading(false);

          let empdata = {
            employee_name: name,
            employee_email: username,
          };

          saveemployee(empdata, username);
        } else {
          logError("Authenticated but no active account found", "useEffect -> isAuthenticated === true");
        }

      } catch (error) {
        logError(error.message, "useEffect -> Authenticated Block", null);
      }
    } else {
      logError("MSAL login failed or user is not authenticated", "useEffect -> isAuthenticated === false");
    }
  }, [isAuthenticated]);


  const checkIfUserDisabled = async (email) => {
    try {
      const res = await Timesheetapi.get(`api/DisabledUser/isUserDisabled?email=${encodeURIComponent(email)}`);
      return res?.data?.isDisabled === true;
    } catch (err) {
      console.log("disabled check failed", err);
      return false; // if the check itself fails, user is allowed in (see note below)
    }
  };


  const saveemployee = async (data, username) => {

    setIsLoading(true);

    const isDisabled = await checkIfUserDisabled(username);
    if (isDisabled) {
      setIsLoading(false);
      messageApi.open({
        type: "error",
        duration: 10,
        content: "Your access has been disabled. Please contact admin.",
      });

      localStorage.removeItem("auth-token");
      localStorage.removeItem("employee_id");
      localStorage.removeItem("emp_role_id");
      localStorage.removeItem("google_token");
      sessionStorage.removeItem("Mslogin");
      sessionStorage.removeItem("UserName");
      sessionStorage.removeItem("AdminLogin");

      setTimeout(async () => {
        try {
          await instance.logoutRedirect();
        } catch (e) {
          console.log("msal logout skipped/not applicable", e);
        }
      }, 10000);

      return;
    }

    let header = {
      'Content-Type': 'application/x-www-form-urlencoded'
    }
    const response = await Timesheetapi.post('api/Projects/employee', data, {
    });
    console.log(response, "response");
    if (response.status == 200) {
      if (localStorage.getItem("auth-token") == null && localStorage.getItem("auth-token") == undefined) {
        const payload = new URLSearchParams();
        payload.append('username', response.data.username);
        payload.append('password', response.data.password);
        payload.append('grant_type', 'password');

        console.log(response.data, "token");
        await Timesheetapi.post('/token', payload, {
          headers: header
        }).then(async (res) => {
          console.log(res);
          LocalStorageService.setToken(res.data.access_token)
          setEmp_Role(response.data.Emp_Role);
          await getemployee(username)
          setIsLoading(true);
        }
        ).catch((err) => {
          console.log(err);
          error();
        });
      }
      else {
        setEmp_Role(localStorage.getItem('emp_role_id'));
        await getemployee(username)
      }


      console.log("Employee saved successfully");
    }
    else {
      const errorLog = {
        Error_Message: response,
        Stack_Trace: '',
        Method_Name: "api/Projects/employee",
        File_Name: 'SSOSignin.js',
        User_Id: username,
      };
      ErrorLog(errorLog)
    }
  }

  const getemployee = async (username) => {
    await Timesheetapi.get(`api/Projects/getemployeebyid/${username}/`).then((response) => {

      console.log("response", response.data.Employee[0].employee_id);

      localStorage.setItem('employee_id', response?.data?.Employee[0]?.employee_id);
      localStorage.setItem('emp_role_id', response?.data?.Employee[0]?.employee_role_id);
      console.log(localStorage.getItem('emp_role_id'), "employee_id");
      if (localStorage.getItem('emp_role_id') != 3 && localStorage.getItem('emp_role_id') != 5) {
        navigate('timesheets', { state: { Username: response.data.username } });
      }
      else if (localStorage.getItem('emp_role_id') == 5) {
        navigate('Settings/ticket', { state: { Username: response.data.username } });
      }
      else {
        navigate('timesheets', { state: { Username: response.data.username } });
      }

    }).catch((err) => {
      console.log("", err);
      const errorLog = {
        Error_Message: err,
        Stack_Trace: '',
        Method_Name: `api/Projects/getemployeebyid/${username}/`,
        File_Name: 'SSOSignin.js',
        User_Id: username,
      };
      ErrorLog(errorLog)
    })

  }

  const HnadleGoogleLogin = () => {

    const CLIENT_ID = `623155047831-5kul72s5ij92bo0ht3r9q8b6rk9330k0.apps.googleusercontent.com`
    const REDIRECT_URL = `https://my.rcktechiees.com/`;
    const STATE = encodeURIComponent('/timesheets');
    const googleAuthUrl = `https://accounts.google.com/o/oauth2/v2/auth?response_type=token&client_id=${CLIENT_ID}&redirect_uri=${REDIRECT_URL}&scope=openid%20email%20profile&state=${STATE}`;
    window.location.href = googleAuthUrl;
    sessionStorage.setItem("Mslogin", false);

  }

  const extractTokenFromUrl = () => {
    const hash = window.location.hash;

    if (hash) {
      const params = new URLSearchParams(hash.substring(1));
      const accessToken = params.get('access_token');
      const state = params.get('state');

      localStorage.setItem("google_token", accessToken);

      if (accessToken) {
        getGoogleAccessToken(accessToken)
      } else {
        console.error('No access token found in URL');
      }
      window.history.replaceState(null, null, state || '/');
    }
  };

  const getGoogleAccessToken = (accessToken) => {
    setIsLoading(true);
    axios
      .get(`https://www.googleapis.com/oauth2/v1/userinfo?access_token=${accessToken}`, {
        headers: {
          Authorization: `Bearer ${accessToken}`,
          Accept: 'application/json'
        }
      })
      .then(async (res) => {
        const data = res.data;

        let empdata = {
          employee_name: data.email.split("@")[0].toUpperCase(),
          employee_email: data.email,
        };

        console.log(empdata, "empdata")
        await saveemployee(empdata, data.email);
        sessionStorage.setItem('UserName', `${data.email}`);
        sessionStorage.setItem('AdminLogin', JSON.stringify(true));
        setIsLoading(false);
        // navigate('/dashboard');
      })
      .catch((err) => console.log(err));
  };

  useEffect(() => {
    if (login == "false") {
      extractTokenFromUrl();
    }
  }, []);


  return (
    <div>
      {contextHolder}
      <div className="h-screen grid grid-cols-2">
        <div className="flex justify-center items-center md:flex">
          <img className="w-full h-full object-cover" src="/Timesheet.jpeg" alt="signin" />
        </div>
        <div className="bg-blue-100 flex flex-col gap-6 justify-center items-center p-10 sm:p-12.5 xl:p-17.5">
          <img className="max-w-[20rem]" src="https://jetzerp.s3.us-east-1.amazonaws.com/images/primary_logo.svg" />
          {isLoading ? Loader : (

            <>
              <div className="flex items-center gap-[15px] w-full">
                <button
                  style={{ backgroundColor: '#18197e' }} // Use inline style
                  className="w-full text-white justify-center px-5 py-5 signin-btn rounded-md flex gap-2 items-center whitespace-nowrap"
                  onClick={handleSignInWithMicrosoft}
                >
                  <img style={{ width: "1.5em" }} src="./microsoft.png" alt="microsoft logo" />
                  Sign in with Microsoft
                </button>

                {/* <p className="text-[14px]"> OR </p> */}

                <button
                  style={{ backgroundColor: '#18197e' }} // Use inline style
                  className="w-full text-white justify-center px-5 py-5 signin-btn rounded-md flex gap-2 items-center whitespace-nowrap"
                  onClick={HnadleGoogleLogin}
                >
                  <img style={{ width: "1.5em" }} src="./google-logo.png" alt="google logo" />
                  Sign in with Google
                </button>
              </div>

            </>
          )}
        </div>
      </div>
    </div>
  );
}
